// UI strings for the Conversation Workspace (Figma file 3TgttrPrba0u2D53deEYqh,
// nodes 6:117 / 23:51 / 18:148). Scoped to this feature only -- apps/web does
// not yet have an app-wide dictionary (spec section 30-32 is UI-only i18n,
// unrelated to what language the assistant replies in). Covers the phase's
// required minimum: English, Arabic (RTL), Amharic, Afaan Oromo.
export const conversationWorkspaceStrings: Record<string, Record<string, string>> = {
  en: {
    newChat: 'New chat',
    searchConversations: 'Search conversations',
    openSidebar: 'Open sidebar',
    closeSidebar: 'Close sidebar',
    closeConversations: 'Close conversations',
    searchToggle: 'Search',
    workspaces: 'Workspaces',
    projects: 'Projects',
    newProject: 'New project',
    project: 'Project',
    manual: 'Manual',
    manualUnavailable: 'Manual mode is not available yet.',
    pinned: 'Pinned',
    recent: 'Recent',
    archived: 'Archived',
    personalWorkspace: 'Personal workspace',
    assistantTitle: 'Assistant',
    personalContext: 'Personal context',
    personal: 'Personal',
    organization: 'Organization',
    autoModel: 'Auto model',
    share: 'Share',
    pin: 'Pin',
    unpin: 'Unpin',
    archive: 'Archive',
    unarchive: 'Unarchive',
    moveToProject: 'Move to project',
    rename: 'Rename',
    renamePrompt: 'New title',
    deleteAction: 'Delete',
    deleteConfirmTitle: 'Delete this conversation?',
    deleteConfirmBody: "This can't be undone.",
    cancel: 'Cancel',
    confirmDelete: 'Delete',
    messagePlaceholder: 'Message OZIRA…',
    disclaimer: 'OZIRA can make mistakes. Check important info.',
    helpful: 'Helpful',
    notHelpful: 'Not helpful',
    copy: 'Copy',
    save: 'Save',
    unsave: 'Remove from saved',
    more: 'More response actions',
    retry: 'Retry',
    send: 'Send',
    toolsTitle: 'Tools & inputs',
    uploadFiles: 'Upload files',
    photoImage: 'Photo / image',
    cameraScan: 'Camera / scan',
    connectors: 'Connectors',
    voice: 'Voice',
    oziraFiles: 'OZIRA Files',
    projectFiles: 'Project files',
    webSearch: 'Web search',
    deepResearch: 'Deep research',
    dataAnalysis: 'Data analysis',
    createImage: 'Create image',
    chooseConnector: 'Choose a connector',
    connectorBack: 'Back',
    connectorSearchPlaceholder: 'Search apps and sources',
    connectorConnect: 'Connect',
    connectorConnected: 'Connected',
    connectorUnavailable: 'Unavailable',
    connectorOrgRestricted: 'Org restricted',
    connectorReauthRequired: 'Reconnect',
    noConversations: 'No conversations yet',
    emptyStateBody: 'Start a new chat to see it here.',
    newChatDefaultTitle: 'New chat',
    noneProject: 'No project',
    sendFailed: 'Could not send that message. Please try again.',
    loadFailed: 'Could not load that conversation. Please try again.',
    shareFailed: 'Could not create a share link. Please try again.',
    shareLinkHint: 'Anyone with this link can view a read-only copy.',
    copyLink: 'Copy link',
  },
  ar: {
    newChat: 'محادثة جديدة',
    searchConversations: 'البحث في المحادثات',
    openSidebar: 'فتح الشريط الجانبي',
    closeSidebar: 'إغلاق الشريط الجانبي',
    closeConversations: 'إغلاق المحادثات',
    searchToggle: 'بحث',
    workspaces: 'مساحات العمل',
    projects: 'المشاريع',
    newProject: 'مشروع جديد',
    pinned: 'مثبّت',
    recent: 'الأخيرة',
    archived: 'مؤرشف',
    personalWorkspace: 'مساحة العمل الشخصية',
    assistantTitle: 'المساعد',
    personalContext: 'سياق شخصي',
    personal: 'شخصي',
    organization: 'المؤسسة',
    autoModel: 'نموذج تلقائي',
    share: 'مشاركة',
    pin: 'تثبيت',
    unpin: 'إلغاء التثبيت',
    archive: 'أرشفة',
    unarchive: 'إلغاء الأرشفة',
    moveToProject: 'نقل إلى مشروع',
    rename: 'إعادة تسمية',
    renamePrompt: 'العنوان الجديد',
    deleteAction: 'حذف',
    deleteConfirmTitle: 'هل تريد حذف هذه المحادثة؟',
    deleteConfirmBody: 'لا يمكن التراجع عن هذا الإجراء.',
    cancel: 'إلغاء',
    confirmDelete: 'حذف',
    messagePlaceholder: 'راسل OZIRA…',
    disclaimer: 'قد يخطئ OZIRA. تحقق من المعلومات المهمة.',
    helpful: 'مفيد',
    notHelpful: 'غير مفيد',
    copy: 'نسخ',
    save: 'حفظ',
    unsave: 'إزالة من المحفوظات',
    more: 'إجراءات إضافية',
    retry: 'إعادة المحاولة',
    send: 'إرسال',
    toolsTitle: 'الأدوات والمدخلات',
    uploadFiles: 'رفع ملفات',
    photoImage: 'صورة',
    cameraScan: 'كاميرا / مسح',
    connectors: 'الموصلات',
    voice: 'صوت',
    oziraFiles: 'ملفات OZIRA',
    projectFiles: 'ملفات المشروع',
    webSearch: 'بحث الويب',
    deepResearch: 'بحث معمّق',
    dataAnalysis: 'تحليل البيانات',
    createImage: 'إنشاء صورة',
    chooseConnector: 'اختر موصلاً',
    connectorSearchPlaceholder: 'ابحث عن تطبيقات ومصادر',
    connectorConnect: 'ربط',
    connectorConnected: 'متصل',
    connectorUnavailable: 'غير متاح',
    connectorOrgRestricted: 'مقيّد من قبل المؤسسة',
    connectorReauthRequired: 'إعادة الاتصال',
    noConversations: 'لا توجد محادثات بعد',
    emptyStateBody: 'ابدأ محادثة جديدة لتظهر هنا.',
    newChatDefaultTitle: 'محادثة جديدة',
    noneProject: 'بدون مشروع',
    sendFailed: 'تعذر إرسال هذه الرسالة. حاول مرة أخرى.',
    loadFailed: 'تعذر تحميل هذه المحادثة. حاول مرة أخرى.',
    shareFailed: 'تعذر إنشاء رابط مشاركة. حاول مرة أخرى.',
    shareLinkHint: 'يمكن لأي شخص يملك هذا الرابط عرض نسخة للقراءة فقط.',
    copyLink: 'نسخ الرابط',
  },
  am: {
    newChat: 'አዲስ ውይይት',
    searchConversations: 'ውይይቶችን ፈልግ',
    openSidebar: 'የጎን ዓምድ ክፈት',
    closeSidebar: 'የጎን ዓምድ ዝጋ',
    closeConversations: 'ውይይቶችን ዝጋ',
    searchToggle: 'ፈልግ',
    workspaces: 'የስራ ቦታዎች',
    projects: 'ፕሮጀክቶች',
    newProject: 'አዲስ ፕሮጀክት',
    pinned: 'የተሰካ',
    recent: 'የቅርብ ጊዜ',
    archived: 'የተመዘገበ',
    personalWorkspace: 'የግል የስራ ቦታ',
    assistantTitle: 'ረዳት',
    personalContext: 'የግል አውድ',
    personal: 'የግል',
    organization: 'ድርጅት',
    autoModel: 'ራስ-ሰር ሞዴል',
    share: 'አጋራ',
    pin: 'ስካ',
    unpin: 'ንቀል',
    archive: 'መዝግብ',
    unarchive: 'ከመዝገብ አውጣ',
    moveToProject: 'ወደ ፕሮጀክት አዛውር',
    rename: 'ስም ቀይር',
    renamePrompt: 'አዲስ ርዕስ',
    deleteAction: 'ሰርዝ',
    deleteConfirmTitle: 'ይህን ውይይት መሰረዝ ይፈልጋሉ?',
    deleteConfirmBody: 'ይህ ተመልሶ ሊታደስ አይችልም።',
    cancel: 'ይቅር',
    confirmDelete: 'ሰርዝ',
    messagePlaceholder: 'ለOZIRA መልእክት…',
    disclaimer: 'OZIRA ስህተት ሊሰራ ይችላል። አስፈላጊ መረጃን ያረጋግጡ።',
    helpful: 'ጠቃሚ',
    notHelpful: 'ጠቃሚ አይደለም',
    copy: 'ቅዳ',
    save: 'አስቀምጥ',
    unsave: 'ከተቀመጡት አስወግድ',
    more: 'ተጨማሪ እርምጃዎች',
    retry: 'እንደገና ሞክር',
    send: 'ላክ',
    toolsTitle: 'መሳሪያዎች እና ግቤቶች',
    uploadFiles: 'ፋይሎችን ስቀል',
    photoImage: 'ፎቶ / ምስል',
    cameraScan: 'ካሜራ / ስካን',
    connectors: 'አገናኞች',
    voice: 'ድምጽ',
    oziraFiles: 'የOZIRA ፋይሎች',
    projectFiles: 'የፕሮጀክት ፋይሎች',
    webSearch: 'የድር ፍለጋ',
    deepResearch: 'ጥልቅ ምርምር',
    dataAnalysis: 'የመረጃ ትንተና',
    createImage: 'ምስል ፍጠር',
    chooseConnector: 'አገናኝ ይምረጡ',
    connectorSearchPlaceholder: 'መተግበሪያዎችን እና ምንጮችን ፈልግ',
    connectorConnect: 'አገናኝ',
    connectorConnected: 'ተያይዟል',
    connectorUnavailable: 'አይገኝም',
    connectorOrgRestricted: 'በድርጅት የተገደበ',
    connectorReauthRequired: 'እንደገና አገናኝ',
    noConversations: 'እስካሁን ውይይት የለም',
    emptyStateBody: 'እዚህ ለማየት አዲስ ውይይት ጀምር።',
    newChatDefaultTitle: 'አዲስ ውይይት',
    noneProject: 'ያለ ፕሮጀክት',
    sendFailed: 'መልእክቱን መላክ አልተቻለም። እባክዎ እንደገና ይሞክሩ።',
    loadFailed: 'ውይይቱን መጫን አልተቻለም። እባክዎ እንደገና ይሞክሩ።',
    shareFailed: 'የማጋሪያ አገናኝ መፍጠር አልተቻለም። እባክዎ እንደገና ይሞክሩ።',
    shareLinkHint: 'ይህ አገናኝ ያለው ማንኛውም ሰው ለንባብ ብቻ የሆነ ቅጂ ማየት ይችላል።',
    copyLink: 'አገናኝ ቅዳ',
  },
  om: {
    newChat: 'Marii haaraa',
    searchConversations: 'Mariiwwan barbaadi',
    openSidebar: 'Sarara cinaa banii',
    closeSidebar: 'Sarara cinaa cufi',
    closeConversations: 'Mari cufi',
    searchToggle: 'Barbaadi',
    workspaces: 'Bakkeewwan Hojii',
    projects: 'Piroojektoota',
    newProject: 'Piroojektii haaraa',
    pinned: 'Kan qabame',
    recent: 'Dhiyoo',
    archived: 'Kan kuufame',
    personalWorkspace: 'Bakka hojii dhuunfaa',
    assistantTitle: 'Gargaaraa',
    personalContext: 'Haala dhuunfaa',
    personal: 'Dhuunfaa',
    organization: 'Dhaabbata',
    autoModel: 'Moodeela ofumaan',
    share: 'Qooda',
    pin: 'Qabi',
    unpin: 'Hiiki',
    archive: 'Kuusi',
    unarchive: 'Kuusaa keessaa baasi',
    moveToProject: 'Gara piroojektiitti dabarsi',
    rename: 'Maqaa jijjiiri',
    renamePrompt: 'Mata duree haaraa',
    deleteAction: 'Haqi',
    deleteConfirmTitle: 'Marii kana haquu barbaaddaa?',
    deleteConfirmBody: 'Kun deebi\'ee hin argamu.',
    cancel: 'Dhiisi',
    confirmDelete: 'Haqi',
    messagePlaceholder: 'OZIRA-f ergaa…',
    disclaimer: 'OZIRA dogoggora hojjechuu danda\'a. Odeeffannoo barbaachisaa mirkaneessi.',
    helpful: 'Gargaaramaa',
    notHelpful: 'Gargaaramaa miti',
    copy: 'Garagalchi',
    save: 'Ol kaa\'i',
    unsave: 'Kan olkaa\'ame irraa balleessi',
    more: 'Tarkaanfiiwwan dabalataa',
    retry: 'Irra deebi\'i yaali',
    send: 'Ergi',
    toolsTitle: 'Meeshaalee fi Galtee',
    uploadFiles: 'Faayilii ol\'kaa\'i',
    photoImage: 'Suuraa',
    cameraScan: 'Kaameraa / Iskaanii',
    connectors: 'Walqunnamtoota',
    voice: 'Sagalee',
    oziraFiles: 'Faayiloota OZIRA',
    projectFiles: 'Faayiloota Piroojektii',
    webSearch: 'Barbaacha Weeb',
    deepResearch: 'Qorannoo gad-fagoo',
    dataAnalysis: 'Xiinxala Deetaa',
    createImage: 'Suuraa Uumi',
    chooseConnector: 'Walqunnamtoo filadhu',
    connectorSearchPlaceholder: 'Aplikeeshinii fi maddoota barbaadi',
    connectorConnect: 'Walqunnamsiisi',
    connectorConnected: 'Walqunnameera',
    connectorUnavailable: 'Hin argamu',
    connectorOrgRestricted: 'Dhaabbataan daangeffame',
    connectorReauthRequired: 'Irra deebi\'ii walqunnamsiisi',
    noConversations: 'Ammatti mariin hin jiru',
    emptyStateBody: 'Marii haaraa jalqabi asitti argamuuf.',
    newChatDefaultTitle: 'Marii haaraa',
    noneProject: 'Piroojektii tokko malee',
    sendFailed: 'Ergaa sana erguun hin danda\'amne. Irra deebi\'ii yaali.',
    loadFailed: 'Marii sana fe\'uun hin danda\'amne. Irra deebi\'ii yaali.',
    shareFailed: 'Hidhaa qooduu uumuu hin dandeenye. Irra deebi\'ii yaali.',
    shareLinkHint: 'Namni hidhaa kana qabu kamiyyuu qabiyyee dubbisuu qofa ilaaluu danda\'a.',
    copyLink: 'Hidhaa garagalchi',
  },
};

export type ConversationWorkspaceKey = keyof typeof conversationWorkspaceStrings.en;
